import { render, staticRenderFns } from "./detailsApply.vue?vue&type=template&id=63c813d0&scoped=true&"
import script from "./detailsApply.vue?vue&type=script&lang=js&"
export * from "./detailsApply.vue?vue&type=script&lang=js&"
import style0 from "./detailsApply.vue?vue&type=style&index=0&id=63c813d0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c813d0",
  null
  
)

export default component.exports